var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#E1EBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3359_3112)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3359_3112)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3359_3112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 23C22.89 23 23.76 22.7361 24.5001 22.2416C25.2401 21.7471 25.8169 21.0443 26.1575 20.2221C26.4981 19.3998 26.5872 18.495 26.4135 17.6221C26.2399 16.7492 25.8113 15.9474 25.182 15.318C24.5526 14.6887 23.7508 14.2601 22.8779 14.0865C22.005 13.9128 21.1002 14.0019 20.2779 14.3425C19.4557 14.6831 18.7529 15.2599 18.2584 15.9999C17.7639 16.74 17.5 17.61 17.5 18.5C17.5012 19.6931 17.9757 20.837 18.8193 21.6807C19.663 22.5243 20.8069 22.9988 22 23ZM22 15.5C22.5933 15.5 23.1734 15.6759 23.6667 16.0056C24.1601 16.3352 24.5446 16.8038 24.7716 17.352C24.9987 17.9001 25.0581 18.5033 24.9424 19.0853C24.8266 19.6672 24.5409 20.2018 24.1213 20.6213C23.7018 21.0409 23.1672 21.3266 22.5853 21.4424C22.0033 21.5581 21.4001 21.4987 20.8519 21.2716C20.3038 21.0446 19.8352 20.6601 19.5056 20.1667C19.1759 19.6734 19 19.0933 19 18.5C19 17.7044 19.3161 16.9413 19.8787 16.3787C20.4413 15.8161 21.2044 15.5 22 15.5Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 24.5C20.2104 24.502 18.4947 25.2138 17.2292 26.4792C15.9638 27.7447 15.252 29.4604 15.25 31.25C15.25 31.4489 15.329 31.6397 15.4697 31.7803C15.6103 31.921 15.8011 32 16 32C16.1989 32 16.3897 31.921 16.5303 31.7803C16.671 31.6397 16.75 31.4489 16.75 31.25C16.75 29.8576 17.3031 28.5223 18.2877 27.5377C19.2723 26.5531 20.6076 26 22 26C23.3924 26 24.7277 26.5531 25.7123 27.5377C26.6969 28.5223 27.25 29.8576 27.25 31.25C27.25 31.4489 27.329 31.6397 27.4697 31.7803C27.6103 31.921 27.8011 32 28 32C28.1989 32 28.3897 31.921 28.5303 31.7803C28.671 31.6397 28.75 31.4489 28.75 31.25C28.748 29.4604 28.0362 27.7447 26.7708 26.4792C25.5053 25.2138 23.7896 24.502 22 24.5Z",
    fill: "#323232"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3359_3112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3359_3112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3359_3112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.2b32e8b8cc8a7a1680d7897a25e01af0.svg";
export { ForwardRef as ReactComponent };